import { ThunkAction } from 'redux-thunk';
import * as authService from '../services/auth';
import { State } from '../reducers/typings';

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT = 'LOGOUT';

interface LoginSuccessAction {
  type: 'LOGIN_SUCCESS';
}

interface LoginFailureAction {
  type: 'LOGIN_FAILURE';
}

interface LogoutAction {
  type: 'LOGOUT';
}

export type AuthAction = LoginSuccessAction | LoginFailureAction | LogoutAction;

function loginSuccess(): LoginSuccessAction {
  return { type: LOGIN_SUCCESS };
}

function loginFailure(): LoginFailureAction {
  return { type: LOGIN_FAILURE };
}

export function login(
  username: string,
  password: string,
): ThunkAction<void, State, void, AuthAction> {
  return async (dispatch): Promise<void> => {
    const authenticationSuccess = await authService.login(username, password);
    dispatch(authenticationSuccess ? loginSuccess() : loginFailure());
  };
}

export function logout(): LogoutAction {
  authService.logout();
  return { type: LOGOUT };
}
